import { render } from "./CustomCategoryMultimediaListView.vue?vue&type=template&id=710be929&scoped=true&ts=true"
import script from "./CustomCategoryMultimediaListView.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryMultimediaListView.vue?vue&type=script&lang=ts"

import "./CustomCategoryMultimediaListView.vue?vue&type=style&index=0&id=710be929&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710be929"]])

export default __exports__